export default `
  query getProductFiltersByCategory($categoryIdFilter: FilterEqualTypeInput!) {
    products(filter: { category_uid: $categoryIdFilter }) {
      aggregations {
        label
        count
        attribute_code
        options {
          count
          label
          value
          __typename
          swatch_data{
            value
            type
          }
        }
        position
        __typename
      }
      __typename
    }
  }
`;
